<template>
  <div id="app" class="">
    <header><Navbar></Navbar></header>
    <main><router-view/></main>
    <Footer></Footer>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'

export default {
  name: 'App',
  components: {
    Navbar,
    Footer
  }
}
</script>

<style>
.patternBG {
  background-image: url("@/../assets/img/spring.png");
}

.main-pattern {
  background-image: url("@/../assets/img/straws.png");
}
body {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}

main {
  flex: 1 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue